import clsx from 'clsx'
import { useState } from 'react'

import type {
  FullShipment,
  HoldAtLocation,
  ShipmentLocation,
} from '@fv/client-types'

import type { TerminalAndType } from '@/features/quote/useTerminals'

import { LegLoad } from './LegLoad'
import { StopCard } from './StopCard'
import type { LegItem } from './types'

type RouteLegProps = {
  destination: ShipmentLocation
  items: LegItem[]
  origin: ShipmentLocation
  holdAtLocation?: HoldAtLocation
  load: FullShipment
  terminals?: TerminalAndType[]
}

export const RouteLeg = ({
  destination,
  items,
  origin,
  holdAtLocation,
  load,
  terminals,
}: RouteLegProps) => {
  const [expanded, setExpanded] = useState(false)
  const hasItems = !!items.length
  const toggleExpanded = () => setExpanded(p => !p)

  return (
    <div className="border-fv-gray border mb-2 flex p-4 flex-col bg-white">
      <div
        className={clsx('justify-between items-stretch flex', {
          'mb-2': hasItems,
        })}
      >
        <StopCard
          expanded={expanded}
          isOrigin
          location={origin}
          toggleExpanded={toggleExpanded}
          workflow={load.workflow}
          terminal={
            origin.type === 'origin'
              ? terminals?.find(t => t.type === 'origin terminal')
              : undefined
          }
        />
        <StopCard
          expanded={expanded}
          location={destination}
          toggleExpanded={toggleExpanded}
          workflow={load.workflow}
          holdAtLocation={holdAtLocation}
          terminal={
            destination.type === 'destination'
              ? terminals?.find(t => t.type === 'destination terminal')
              : undefined
          }
        />
      </div>

      {hasItems && (
        <ol className="divide divide-y divide-fv-gray [counter-reset:ol-list-num] list-num">
          {items.map(i => (
            <LegLoad
              className={`route-color-${destination.type} p-4 pl-10 relative leading-6 before:absolute before:left-0 before:top-[.6rem] before:w-[1.85em] before:h-[1.85em] before:rounded-full before:bg-white before:text-fv-gray-light before:border-2
              before:flex
              before:items-center
              before:justify-center
              before:border-fv-gray
              before:content-[counter(ol-list-num)]
           before:[counter-increment:ol-list-num]`}
              item={i}
              key={i._id}
              load={load}
            />
          ))}
        </ol>
      )}
    </div>
  )
}
